import { getFromLocalStorage } from "~/utils";
import { getThemeData } from "~/utils";

export default defineNuxtRouteMiddleware(async (to, from) => {

    if (getStateValue("userId") && getStateValue("codeCampaign"))
        return;

    const themeData = getThemeData()
    const theme = themeData.theme;
    const baseUrl = themeData.config.baseUrl;
    const firstParam = to.params.step as string;

    let userId: string | null, 
    codeCampaign: string | null, 
    trackCode: string | null;


    if (/^[0-9]{9}/.test(firstParam)) 
    {
        userId = firstParam;
        codeCampaign = baseUrl as string;
        trackCode = to.params.trackCode as string ?? null;
    } 
    else if (to.query.u && to.query.c) {
        userId = to.query.u as string;
        codeCampaign = to.query.c as string;
        trackCode = to.query.t as string ?? null;
    } else {
        userId = getFromLocalStorage(`${theme}_user_id`)
        codeCampaign = getFromLocalStorage(`${theme}_code_campaign`)
        trackCode = getFromLocalStorage(`${theme}_track_code`)
    }

    updateStateValue("userId", userId)
    updateStateValue("codeCampaign", codeCampaign)
    updateStateValue("trackCode", trackCode)
    localStorage.setItem(`${theme}_user_id`, userId!);
    localStorage.setItem(`${theme}_code_campaign`, codeCampaign!);
    localStorage.setItem(`${theme}_track_code`, trackCode as string);
})